module.exports = __webpack_public_path__ + "img/person_remove_black_24dp.58dbdd07.svg";